import { render, staticRenderFns } from "./PrimeCompletePopup.vue?vue&type=template&id=eba70706&scoped=true"
import script from "./PrimeCompletePopup.vue?vue&type=script&setup=true&lang=ts"
export * from "./PrimeCompletePopup.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PrimeCompletePopup.vue?vue&type=style&index=0&id=eba70706&prod&lang=scss&scoped=true"
import style1 from "./PrimeCompletePopup.vue?vue&type=style&index=1&id=eba70706&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eba70706",
  null
  
)

export default component.exports